import React from 'react';
import Select from 'react-select';

export default function DraftIssueModal({
  open, onClose, draftFields, fieldMeta, selectOptions, onChange, onSubmit, loading
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm animate-fade-in">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-xl relative animate-modal-in">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl">✕</button>
        <h2 className="text-2xl font-bold mb-6 text-blue-900">Review & Edit Draft Issue</h2>
        <form onSubmit={onSubmit} className="space-y-5">
          {Object.entries(draftFields).map(([field, value]) => {
            const meta = fieldMeta[field] || {};
            const isSelect = meta.type === 'select' || meta.type === 'single' || meta.type === 'multi';
            const options = selectOptions[field] || [];
            return (
              <div key={field} className="flex flex-col gap-1">
                <label className="font-semibold text-gray-700 flex items-center gap-2">
                  {meta.label || field}
                  {meta.confidence !== undefined && (
                    <span className={`ml-2 px-2 py-0.5 rounded text-xs font-medium ${meta.confidence >= 0.8 ? 'bg-green-100 text-green-700' : meta.confidence >= 0.5 ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}`}>
                      {`Confidence: ${(meta.confidence * 100).toFixed(0)}%`}
                    </span>
                  )}
                  {meta.rationale && (
                    <span className="ml-2 text-xs text-gray-400 italic">{meta.rationale}</span>
                  )}
                </label>
                {isSelect ? (
                  <Select
                    isMulti={meta.type === 'multi'}
                    value={options.filter(opt => (meta.type === 'multi' ? value?.includes(opt.value) : opt.value === value))}
                    onChange={selected => onChange(field, meta.type === 'multi' ? selected.map(opt => opt.value) : selected?.value)}
                    options={options}
                    className="react-select-container"
                    classNamePrefix="react-select"
                  />
                ) : (
                  <input
                    type={meta.type === 'date' ? 'date' : 'text'}
                    value={value || ''}
                    onChange={e => onChange(field, e.target.value)}
                    className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-blue-500"
                  />
                )}
              </div>
            );
          })}
          <div className="flex justify-end gap-3 pt-6 border-t mt-6">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">Cancel</button>
            <button type="submit" disabled={loading} className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 disabled:opacity-50">{loading ? 'Creating...' : 'Create Issue'}</button>
          </div>
        </form>
      </div>
    </div>
  );
} 